import { readableColor } from 'polished';

import { VariantLogoProps } from '.';

export const factor = 89 / 104;

export const Component = ({
	width = 'auto',
	height = 'auto',
	fill,
	...props
}: VariantLogoProps) => (
	<svg
		width={104}
		height={89}
		viewBox="0 0 104 89"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		style={{
			width,
			height,
		}}
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M18.4228 0C8.24817 0 0 8.24817 0 18.4228V70.0065C0 80.1811 8.24817 88.4293 18.4228 88.4293H84.7447C94.9193 88.4293 103.168 80.1811 103.168 70.0065V18.4228C103.168 8.24817 94.9193 0 84.7447 0H18.4228ZM23.0763 30.9643C21.6374 32.4031 21.6374 34.7361 23.0763 36.175L34.8006 47.8992L23.0763 59.6235C21.6374 61.0623 21.6374 63.3953 23.0763 64.8342C24.5152 66.273 26.8482 66.273 28.2871 64.8342L42.6167 50.5046C44.0555 49.0657 44.0555 46.7327 42.6167 45.2939L28.2871 30.9643C26.8481 29.5254 24.5152 29.5254 23.0763 30.9643ZM44.2146 62.6374C44.2146 60.6024 45.8642 58.9529 47.8992 58.9529H70.0065C72.0415 58.9529 73.6911 60.6024 73.6911 62.6374C73.6911 64.6724 72.0415 66.322 70.0065 66.322H58.9529H47.8992C45.8642 66.322 44.2146 64.6724 44.2146 62.6374Z"
			fill={fill}
		/>
		<path
			d="M23.0763 30.9643C21.6374 32.4031 21.6374 34.7361 23.0763 36.175L34.8006 47.8992L23.0763 59.6235C21.6374 61.0623 21.6374 63.3953 23.0763 64.8342C24.5152 66.273 26.8482 66.273 28.2871 64.8342L42.6167 50.5046C44.0555 49.0657 44.0555 46.7327 42.6167 45.2939L28.2871 30.9643C26.8481 29.5254 24.5152 29.5254 23.0763 30.9643Z"
			fill={readableColor(fill)}
		/>
		<path
			d="M44.2146 62.6374C44.2146 60.6024 45.8642 58.9529 47.8992 58.9529H70.0065C72.0415 58.9529 73.6911 60.6024 73.6911 62.6374C73.6911 64.6724 72.0415 66.322 70.0065 66.322H58.9529H47.8992C45.8642 66.322 44.2146 64.6724 44.2146 62.6374Z"
			fill={readableColor(fill)}
		/>
	</svg>
);
